import { useAuth } from 'hooks/UseAuth'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
/**
 * Determines A/B test assignment based on user ID
 * Even user IDs get version A, odd user IDs get version B
 */
export const getABTestAssignment = (userId: number): 'A' | 'B' => {
  return userId % 2 === 0 ? 'A' : 'B'
}

/**
 * Hook to get A/B test assignment for the current user
 * Can use feature flags to override
 * - abtest_force_a: Force users to group A
 * - abtest_force_b: Force users to group B
 */
export const useABTestAssignment = (): 'A' | 'B' | null => {
  const auth = useAuth()
  const forceGroupA = useFlipperFlag('ab_test_force_a')
  const forceGroupB = useFlipperFlag('ab_test_force_b')

  if (!auth?.id) {
    return null
  }

  if (forceGroupB) {
    return 'B'
  }

  if (forceGroupA) {
    return 'A'
  }

  // Default behavior: use user ID to determine group
  return getABTestAssignment(auth.id)
}
